
export default {
  name: "UiZoomImage",
  props: {
    src: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      default: "",
    },
    zoomScale: {
      type: Number,
      default: 2.5,
    },
    clickToZoom: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isZooming: false,
      isClickZoomed: false,
      zoomX: 0,
      zoomY: 0,
      containerWidth: 0,
      containerHeight: 0,
      touchStartTime: 0,
    };
  },
  computed: {
    zoomedImageStyle() {
      if (!this.isZooming && !this.isClickZoomed) {
        return {};
      }

      const scale = this.zoomScale;
      const originX = (this.zoomX / this.containerWidth) * 100;
      const originY = (this.zoomY / this.containerHeight) * 100;

      return {
        transform: `scale(${scale})`,
        transformOrigin: `${originX}% ${originY}%`,
      };
    },
  },
  methods: {
    handleZoomMove(event) {
      if (this.disabled) {
        return;
      }
      if (!this.isClickZoomed && this.clickToZoom) {
        return;
      }
      const container = event.currentTarget;
      const rect = container.getBoundingClientRect();
      this.containerWidth = rect.width;
      this.containerHeight = rect.height;
      this.zoomX = event.clientX - rect.left;
      this.zoomY = event.clientY - rect.top;
    },
    handleZoomEnter(event) {
      if (this.disabled) {
        return;
      }
      if (this.clickToZoom && !this.isClickZoomed) {
        return;
      }
      const container = event.currentTarget;
      const rect = container.getBoundingClientRect();
      this.containerWidth = rect.width;
      this.containerHeight = rect.height;
      this.isZooming = true;
    },
    handleZoomLeave() {
      if (this.disabled) {
        return;
      }
      if (this.clickToZoom && this.isClickZoomed) {
        return;
      }
      this.isZooming = false;
    },
    handleClick(event) {
      if (this.disabled || !this.clickToZoom) {
        return;
      }

      const container = event.currentTarget;
      const rect = container.getBoundingClientRect();
      this.containerWidth = rect.width;
      this.containerHeight = rect.height;

      if (event.clientX && event.clientY) {
        this.zoomX = event.clientX - rect.left;
        this.zoomY = event.clientY - rect.top;
      }

      this.isClickZoomed = !this.isClickZoomed;
      if (!this.isClickZoomed) {
        this.isZooming = false;
      }
    },
    handleTouchStart(event) {
      if (this.disabled || !this.clickToZoom) {
        return;
      }
      this.touchStartTime = Date.now();
      if (event.touches.length === 1) {
        const touch = event.touches[0];
        const container = event.currentTarget;
        const rect = container.getBoundingClientRect();
        this.containerWidth = rect.width;
        this.containerHeight = rect.height;
        this.zoomX = touch.clientX - rect.left;
        this.zoomY = touch.clientY - rect.top;
      }
    },
    handleTouchMove(event) {
      if (this.disabled || !this.clickToZoom) {
        return;
      }
      if (!this.isClickZoomed) {
        return;
      }
      event.preventDefault();
      if (event.touches.length === 1) {
        const touch = event.touches[0];
        const container = event.currentTarget;
        const rect = container.getBoundingClientRect();
        this.zoomX = touch.clientX - rect.left;
        this.zoomY = touch.clientY - rect.top;
      }
    },
    handleTouchEnd(event) {
      if (this.disabled || !this.clickToZoom) {
        return;
      }
      const touchDuration = Date.now() - this.touchStartTime;
      // If touch was short (< 200ms), toggle zoom
      if (touchDuration < 200) {
        this.isClickZoomed = !this.isClickZoomed;
      }
    },
  },
};
